import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CalendarComponent from "../../../components/calendar";
import AppLoader from "../../../components/loader";
import { AppContext } from "../../../lib/Context";
import { getfollowUpDates } from "../../../services/ContractApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import AppHeader from "../../../components/header/index";
import { useNavigate } from "react-router-dom";
// import {
//   setLeadEndDate,
//   setLeadSaleStatusValue,
//   setLeadSearchValue,
//   setLeadStartDate,
//   setProposalSearchValueForAgent,
// } from "../../../lib/redux/slices/searchKeysSlice";
import { Box, Stack } from "@mui/material";
import { setCurrentPage } from "../../../lib/redux/slices/contractPaginateSlice";
import { exportMeetingLeads, getAllMeetingDetails } from "../../../services/LeadProposalApi";
import { LEAD_STAGE } from "../../../lib/Variable";
import GlobalButton from "../../../components/button";
import { CSVLink } from "react-csv";
import moment from "moment";




const MeetingDatesComponent = () => {
  const csvRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [allMeetingDates, setAllMeetingDates] = useState([]);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [allMeetings, setAllMeetings] = useState([]);


  const getAllMeetingDates = async () => {
    setIsLoading(true);
    try {
      const response = await getAllMeetingDetails();
      if (response.data.status === "success") {
        const data = response.data.data;
        const newData = data?.map((x) => {
          const findColorCode = LEAD_STAGE.find((y) => y.value === x.leadStage);
          return ({
            id: x._id,
            title: x.meeterName || "NA",
            businessName: x.businessName || "NA",
            start: new Date(x.setMeeting),
            end: new Date(x.setMeeting),
            username: x.username || "NA",
            meetingDateTime: x.setMeeting,
            contact: x.contact || "NA",
            agentName: x.agentName || "NA",
            address: x.address || "NA",
            note: x.note || "NA",
            allDay: true,
            type: "meeting",
            colorCode: findColorCode?.colorCode || "#C8E6C9",
          })
        });

        setAllMeetingDates(newData);
      } else {
        handleOpenSnackBar(response.data.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllMeetingDates();
  }, []);



  const exportAllMeetings = async () => {
    try {
      setIsExportLoading(true);
      const result = await exportMeetingLeads();
      if (result.data.status === "success") {
        setAllMeetings(result.data.data);
        setTimeout(() => {
          if (csvRef.current) {
            csvRef.current.link.click();
          }
        }, 100);
      } else {
        handleOpenSnackBar("error", result.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message || "Export failed");
    } finally {
      setIsExportLoading(false);
    }
  };



  const CSV_HEADERS = [
    { label: "Created On", key: "createdAt" },
    { label: "Updated On", key: "updatedAt" },
    { label: "Agent", key: "agentName" },
    { label: "Product Type", key: "productType" },
    { label: "Current Provider", key: "currentProvider" },
    { label: "Username", key: "username" },
    { label: "Business Name", key: "businessName" },
    { label: "Email", key: "email" },
    { label: "Contact", key: "contact" },
    { label: "Address", key: "address" },
    { label: "Meeter Name", key: "meeterName" },
    { label: "Meeting Date", key: "meetingDateTime" },
    { label: "Note", key: "note" },
    { label: "Lead Stage", key: "leadStage" },
  ];

  const downloadData = () => {
    return allMeetings.map((val) => {

      const findLeadStage = LEAD_STAGE.find((y) => y.value === val.leadStage);

      return {
        createdAt: moment(val.createdAt).format("DD.MM.YY [at] HH:mm") || "",
        updatedAt: moment(val.updatedAt).format("DD.MM.YY [at] HH:mm") || "",
        agentName: val.agentId?.username || "",
        productType: val.productType?.name || "",
        currentProvider: val.currentProvider || "",
        username: val.username || "",
        businessName: val.businessName || "",
        email: val.email || "",
        contact: val.contact || "",
        address: val.address || "",
        meeterName: val.meeterName || "",
        meetingDateTime: val.setMeeting ? moment(val.setMeeting).format("DD.MM.YY [at] HH:mm") : "",
        note: val.note || "",
        leadStage: findLeadStage?.title || "",
      };
    });
  };

  return (
    <Box>
      <AppLoader isVisible={isLoading} />

      <CSVLink
        data={downloadData()}
        headers={CSV_HEADERS}
        filename={"meetings.csv"}
        className="btn btn-primary"
        target="_blank"
        ref={csvRef}
      />

      <Stack direction={"row"} justifyContent={"flex-end"} alignItems={"center"} gap={2} mb={2}>
        <GlobalButton
          variant={"custom_gradient"}
          title={
            isExportLoading ? "Exporting Meetings" : "Export Meetings"
          }
          disabled={isExportLoading}
          handleClickBtn={exportAllMeetings}
          style={{
            width: "auto",
            height: 35,
            borderRadius: "8px",
          }}
        />
      </Stack>

      <CalendarComponent
        data={allMeetingDates || []}
        // onSelectEvent={handleSelectMeeting}
        title={"Meeting Dates"}
        dataType="meeting"
      />
    </Box>
  );
};

export default MeetingDatesComponent;
